function isCheckerboardMobile() {
  return window.matchMedia('(max-width: 991.98px)').matches;
}

function syncProductModalBody() {
  const source = document.getElementById('productUpdate');
  const dest = document.getElementById('productUpdateModalBody');
  if (!source || !dest) return;
  // Fallback, если AJAX обновил только десктопный блок
  if (source.querySelector('.checkerboard-preview')) {
    dest.innerHTML = source.innerHTML;
  }
}

function closeCheckerboardProductModal() {
  const modalEl = document.getElementById('checkerboardProductModal');
  if (!modalEl) return;

  if (window.bootstrap?.Modal) {
    const instance = window.bootstrap.Modal.getInstance(modalEl);
    instance?.hide();
    return;
  }

  if (window.jQuery?.fn?.modal) {
    window.jQuery(modalEl).modal('hide');
  }
}

function openCheckerboardProductModal() {
  if (!isCheckerboardMobile()) return;

  syncProductModalBody();

  const modalEl = document.getElementById('checkerboardProductModal');
  const body = document.getElementById('productUpdateModalBody');
  if (!modalEl || !body?.querySelector('.checkerboard-preview')) {
    closeCheckerboardProductModal();
    return;
  }

  if (window.bootstrap?.Modal) {
    window.bootstrap.Modal.getOrCreateInstance(modalEl).show();
    return;
  }

  if (window.jQuery?.fn?.modal) {
    window.jQuery(modalEl).modal('show');
  }
}

function fitCheckerboardGrid(page) {
  const wrappers = page.querySelectorAll('.checkerboard-wrapper');
  if (!wrappers.length) return;

  const layout = page.querySelector('.checkerboard-layout');
  const layoutW = layout ? layout.clientWidth : window.innerWidth;
  const isNarrow = window.innerWidth < 576;
  const isDesktop = window.innerWidth >= 992;
  // На ПК шахматка занимает левую колонку; даём чуть больше места под крупные ячейки
  const maxGridW = isNarrow
    ? layoutW
    : Math.max(200, layoutW * (isDesktop ? 0.62 : 0.55));

  // Один размер для всех корпусов — по максимальному числу квартир в ряду
  let globalMaxCols = 1;
  wrappers.forEach((wrapper) => {
    wrapper.querySelectorAll('.checkerboard-list-wrapper').forEach((rowEl) => {
      const cells = rowEl.querySelectorAll('.checkerboard-product-item').length;
      if (cells > globalMaxCols) globalMaxCols = cells;
    });
  });

  const styles = getComputedStyle(wrappers[0]);
  const gap = parseFloat(styles.getPropertyValue('--cb-gap')) || 4;
  const numW = parseFloat(styles.getPropertyValue('--cb-num')) || 18;

  const cellByWidth =
    (maxGridW - numW - gap - 4 - gap * Math.max(0, globalMaxCols - 1)) / globalMaxCols;

  // Без привязки к remaining viewport height: иначе нижние корпуса сжимаются
  const ideal = isDesktop
    ? 30 + (22 * window.innerWidth) / 1920
    : 22 + (16 * window.innerWidth) / 1920;

  const cell = isNarrow
    ? Math.max(20, cellByWidth)
    : Math.max(18, Math.min(ideal, cellByWidth));

  const cellPx = `${cell.toFixed(2)}px`;
  wrappers.forEach((wrapper) => {
    wrapper.style.setProperty('--cb-cell', cellPx);
  });
}

function bindEntranceMenus(page) {
  page.querySelectorAll('[data-checkerboard-entrances]').forEach((entrances) => {
    if (entrances.dataset.bound === '1') return;
    entrances.dataset.bound = '1';

    const trigger = entrances.querySelector('.checkerboard-entrances__trigger');
    const menu = entrances.querySelector('.checkerboard-entrances__menu');
    trigger?.addEventListener('click', (e) => {
      e.preventDefault();
      const open = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (menu) menu.hidden = open;
    });
    entrances.querySelectorAll('[data-entrance]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const entrance = btn.getAttribute('data-entrance');
        const buildingSlug = entrances.getAttribute('data-building-slug');
        const url = new URL(window.location.href);
        url.searchParams.set('entrance', entrance);
        if (buildingSlug) {
          url.searchParams.set('building', buildingSlug);
        }
        window.location.href = url.toString();
      });
    });
    document.addEventListener('click', (e) => {
      if (!entrances.contains(e.target)) {
        trigger?.setAttribute('aria-expanded', 'false');
        if (menu) menu.hidden = true;
      }
    });
  });
}

function initCheckerboard() {
  const page = document.querySelector('.checkerboard-page');
  if (!page) return;

  bindEntranceMenus(page);

  page.addEventListener('click', (e) => {
    const cell = e.target.closest('.checkerboard-product-item.app-display-product');
    if (!cell) return;
    page.querySelectorAll('.checkerboard-product-item.is-selected').forEach((el) => {
      el.classList.remove('is-selected');
    });
    cell.classList.add('is-selected');
  });

  const scheduleFit = () => {
    window.requestAnimationFrame(() => fitCheckerboardGrid(page));
  };

  scheduleFit();
  window.addEventListener('resize', scheduleFit);
  window.addEventListener('orientationchange', scheduleFit);

  if (window.jQuery) {
    window.jQuery(document).on('ajaxUpdate', '#checkerboardGrid', () => {
      bindEntranceMenus(page);
      scheduleFit();
      closeCheckerboardProductModal();
    });
    window.jQuery(document).on('ajaxUpdate', '#productUpdate', () => {
      openCheckerboardProductModal();
    });
    window.jQuery(document).on('ajaxDone', scheduleFit);
  }
}

document.addEventListener('DOMContentLoaded', initCheckerboard);
